import Vue from 'vue'
import router from "./router";
import store from './store'
import {getUrlQuery , entranceJump,deepClone} from "./utils/fristJump";
router.beforeEach((to, from, next) => {
  /*路由发生改变修改页面的title */
  if(to.meta.title) { document.title = to.meta.title }
  next();
})



// WEBPACK FOOTER //
// ./src/authentication.js